import componentize from './componentize';
import $ from 'jquery';
/* global window */
/* global document */
export default function () {
    componentize({
        query: 'section.expandable',
        attachedCallback: function () {
            this.addEventListener('click', this.clickHandler.bind(this));
        },
        clickHandler: function () {
            this.toggle();
            let $this = $(this);
            $('section.expandable').each(function () {
                if (this !== $this[0]) {
                    this.toggle(true);
                }
            });
        },
        toggle: function (forceClose) {
            var $this = $(this);
            var name = $this.data('name');
            var $expansion = $(`ul[data-name=${name}]`);
            if ($this.hasClass('open') || forceClose) {
                this.close($this, $expansion);
            } else {
                this.open($this, $expansion);
            }
        },
        close: function ($this, $expansion) {
            $this.removeClass('open');
            $expansion.slideUp(500, () => { $expansion.removeClass('open'); });
        },
        open: function ($this, $expansion) {
            $this.addClass('open');
            $expansion.slideDown(500, () => { $expansion.addClass('open'); });
        }
    });
}
